var map = {
	"./buy-active.png": "0VH6",
	"./buy.png": "h/w3",
	"./category-active.png": "HwW9",
	"./category.png": "yk7w",
	"./commondisease-active.png": "/2DK",
	"./commondisease.png": "m54/",
	"./daily-warn-active.png": "GR0m",
	"./daily-warn.png": "9FSX",
	"./dorm-active.png": "ePod",
	"./dorm-warn-active.png": "y2su",
	"./dorm-warn.png": "50O7",
	"./dorm.png": "8rUf",
	"./expellinginsects-active.png": "5arC",
	"./expellinginsects.png": "P0vf",
	"./home-active.png": "X4/I",
	"./home.png": "+B9e",
	"./ill-warn-active.png": "og3E",
	"./ill-warn.png": "HMVY",
	"./log-active.png": "OXQ0",
	"./log.png": "EJZI",
	"./order-active.png": "Go43",
	"./order.png": "7YvB",
	"./pet-active.png": "i8o8",
	"./pet.png": "X9vh",
	"./product-brand-active.png": "I1r0",
	"./product-brand.png": "cgvZ",
	"./product-list-active.png": "xvOR",
	"./product-list.png": "YdTu",
	"./purchase-active.png": "40C5",
	"./purchase.png": "Ss5z",
	"./role-active.png": "CdVW",
	"./role.png": "Qomh",
	"./sms-new-active.png": "r0Ur",
	"./sms-new.png": "ATo1",
	"./staff-active.png": "bdtf",
	"./staff.png": "Ozbk",
	"./stage-warn-active.png": "JB6V",
	"./stage-warn.png": "pyaV",
	"./store-active.png": "ICOI",
	"./store-warn-active.png": "D+Hb",
	"./store-warn.png": "DAZr",
	"./store.png": "D3rF",
	"./sysShop-active.png": "S3Pu",
	"./sysShop.png": "LiUd",
	"./systen-set-active.png": "oJHC",
	"./systen-set.png": "ARwA",
	"./ums-admin-active.png": "6rXd",
	"./ums-admin.png": "kyVR",
	"./vaccine-active.png": "Z/Pu",
	"./vaccine.png": "6NsX"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "hFzH";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu ^\.\/.*\.png$
// module id = hFzH
// module chunks = 58